/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const NotificationSummaryParser = /* #__PURE__ */ parsers.object([['unreadCount', codecNumber, 'unread_count']]);
export class NotificationSummary extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NotificationSummaryParser.decode(input).map(res => new NotificationSummary(res));
    }
    static unsafeDecode(input) {
        return NotificationSummary.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NotificationSummaryParser.encode(data);
    }
    static schema() {
        return NotificationSummaryParser.schema();
    }
}
